<template>
  <v-layout row wrap justify-center :class="color">

    <ui-title-cen title="Actividad"></ui-title-cen>
    <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc :vidTittle="'Actividad'" videoEmbed="ADMINISTRACIONDINERO07_01ActividadPresentacio.mp4"></ui-simple-lsc>
      </v-flex>

    <v-layout row justify-center class="animated fadeInUp dura_1">
      <v-flex sm8>
        <p>
          En la siguiente actividad, usted puede ayudar a Juliana a tomar las decisiones 
          correctas para que pueda alcanzar su <strong>meta</strong>. <br>
          Para conseguirlo debe hacer clic en los botones, tomar las decisiones más acertadas y avanzar en la historia.<br><br>
          Solo al finalizar podrá comprobar si logró acercarse a la meta.

        </p>
      </v-flex>
    </v-layout>

    <v-flex xs12 text-xs-center class="animated bounceIn dura_2">
      <br>
      <router-link :to="linksPath+(currentPage+1)" aria-label="Iniciar actividad">
        <ui-button :content="'Iniciar actividad'" :botSize="250" :aria="'Iniciar actividad'" @click.native="dialogOne = true"></ui-button>
      </router-link>
    </v-flex>

  </v-layout>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    color() {
      return this.$store.state.color;
    },
    linksPath() {
      return this.$store.state.linksPath;
    },
    currentPage() {
      return Math.floor(this.$route.params.unipage);
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// davivienda-07.vue?764a2100